const SITE_STORAGE_KEY = "kitchen-hub-selected-site";

type SiteStorage = Pick<Storage, "getItem" | "setItem" | "removeItem">;

/**
 * The site chosen once at sign-in, remembered per device.
 *
 * Kitchen PCs are shared and stay signed in, so asking which site you are
 * standing in on every screen was both repetitive and easy to get wrong. The
 * choice is keyed by organization: a member who moves between organizations
 * must not inherit a site id belonging to a different one, which would send
 * every site-scoped call to a site they cannot see.
 */
export function readSelectedSite(storage: SiteStorage | null, organizationId: string): string | null {
  try {
    const raw = storage?.getItem(SITE_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as { organization_id: string; site_id: string };
    if (parsed.organization_id !== organizationId) return null;
    return parsed.site_id || null;
  } catch {
    return null;
  }
}

export function writeSelectedSite(
  storage: SiteStorage | null,
  organizationId: string,
  siteId: string | null,
): void {
  try {
    if (siteId) {
      storage?.setItem(SITE_STORAGE_KEY, JSON.stringify({ organization_id: organizationId, site_id: siteId }));
    } else {
      storage?.removeItem(SITE_STORAGE_KEY);
    }
  } catch {
    // A device with storage disabled simply asks for the site again each session.
  }
}
